module.exports = __webpack_public_path__ + "static/media/abb-logo.95d2f25e.svg";